import { BackButton, FilteredCreditApplication } from '@applyonline/shared'
import { Navigate } from 'react-router-dom'
import UploadFilesTable from '../../../../components/UploadFilesTable'
import useRequiredDocumentsWithStatus from '../../../../data/creditapp-hooks'
import { areAllRequiredDocumentsApproved } from '../../../../data/creditapp-selectors'

interface Props {
  creditApp: FilteredCreditApplication
}

const DocumentsPage = ({ creditApp }: Props) => {
  const requiredDocumentsWithStatusList = useRequiredDocumentsWithStatus(
    creditApp.requiredDocuments,
    creditApp.documents,
  )
  if (areAllRequiredDocumentsApproved(requiredDocumentsWithStatusList)) return <Navigate to=".." replace />
  return (
    <main className="general-message">
      <UploadFilesTable creditApp={creditApp} />
      <BackButton href=".." />
    </main>
  )
}

export default DocumentsPage
